var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }